/* eslint-disable no-nested-ternary */

import { translates } from '@/utils';
import { currentFormat } from '@/utils/cases';
import { Box, Card, CardProps, Stack } from '@mui/material';

interface Props extends CardProps {
  title: string;
  data: any;
}

export default function LogCashRegister({ title, data, color = 'primary', sx, ...other }: Props) {
  const { cash, creditCard, transference } = data;

  const total = currentFormat(cash + creditCard + transference);

  return (
    <Card
      sx={{
        p: 3,
        height: '100%',
        borderRadius: 2,
        backgroundColor: 'common.white',
        ...sx,
      }}
      {...other}
    >
      <Stack>
        <div>
          <Box sx={{ mb: 1, typography: 'subtitle2' }}>{title}</Box>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span>{translates.cash}</span>
          <span style={{ fontSize: 'small' }}>{currentFormat(cash ?? 0)}</span>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span>{translates.creditCard}</span>
          <span style={{ fontSize: 'small' }}>{currentFormat(creditCard ?? 0)}</span>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span>{translates.transference}</span>
          <span style={{ fontSize: 'small' }}>{currentFormat(transference ?? 0)}</span>
        </div>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <span>{translates.total}</span>
          <span style={{ fontSize: 'small' }}>{total ?? 0}</span>
        </div>
      </Stack>
      {/* {
          JSON.stringify(data)
        } */}
    </Card>
  );
}
